import { render, staticRenderFns } from "./CVerticalScheduler.vue?vue&type=template&id=49c0fbe1&scoped=true"
import script from "./CVerticalScheduler.vue?vue&type=script&lang=js"
export * from "./CVerticalScheduler.vue?vue&type=script&lang=js"
import style0 from "./CVerticalScheduler.vue?vue&type=style&index=0&id=49c0fbe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0fbe1",
  null
  
)

export default component.exports